<template>
  <div>
    <base-dialog
      :show="!!error.description"
      title="An error occurred"
      @close="handleError"
    >
      <p>{{ error.description }}</p>
    </base-dialog>
    <base-card>
      <h1>Weekly Results</h1>
      <div v-if="preTournament && nextWeek > 1">
        <h2>Picks are currently open, close picks to record weekly results</h2>
      </div>
      <div v-else>
        <div v-if="preTournament && nextWeek === 1">
          <h2>Picks are currently open, you can only update week 1 picks</h2>
        </div>
        <base-card>
          <div
            v-for="week in weeks"
            :key="week"
            @click="switchWeek(week)"
            class="weeks--list"
            :class="weeksListStyle(week)"
            :ref="'week_' + week"
          >
            Week {{ week }}
          </div>
        </base-card>
        <div>
          <base-card>
            Week {{ showWeek }} (Points / Game = {{ weekPoints(showWeek) }})
            <ol>
              <li v-for="game in weekGames(showWeek)" :key="game.gameId">
                <div style="justify-content: center">
                  <div class="div--visitor">
                    <input
                      type="radio"
                      :id="game.gameId + '_Visitor'"
                      :name="game.gameId"
                      :value="game.visitor"
                      v-model="game.winner"
                    />
                    <label
                      class="label--visitor"
                      :for="game.gameId + '_Visitor'"
                      >{{ game.visitor }}</label
                    >
                  </div>
                  <div class="div--home">
                    <input
                      type="radio"
                      :id="game.gameId + '_Home'"
                      :name="game.gameId"
                      :value="game.home"
                      v-model="game.winner"
                    />
                    <label class="label--home" :for="game.gameId + '_Home'">{{
                      game.home
                    }}</label>
                  </div>
                  <div class="div--tie">
                    <input
                      type="radio"
                      :id="game.gameId + '_Tie'"
                      :name="game.gameId"
                      value="TIE"
                      v-model="game.winner"
                    />
                    <label class="label--tie" :for="game.gameId + '_Tie'"
                      >TIE</label
                    >
                  </div>
                  <div class="div--none">
                    <input
                      type="radio"
                      :id="game.gameId + '_None'"
                      :name="game.gameId"
                      value=""
                      v-model="game.winner"
                    />
                    <label class="label--none" :for="game.gameId + '_None'"
                      >None</label
                    >
                  </div>
                </div>
              </li>
            </ol>
            <div class="buttons--list">
              <base-button
                @click="saveChanges"
                class="button--save"
                :disabled="!dataChanged"
                >Save</base-button
              >
              <base-button
                @click="resetChanges"
                class="button--reset"
                :disabled="!dataChanged"
                >Reset</base-button
              >
            </div>
            <div style="clear: both"></div>
          </base-card>
        </div>
      </div>
    </base-card>
  </div>
</template>

<script>
import ShowSnackbar from "../../mixins/ShowSnackbar.js";

export default {
  mixins: [ShowSnackbar],
  computed: {
    currentSchedule() {
      return this.$store.getters["schedules/currentSchedule"];
    },
    currentSeason() {
      return this.$store.getters["seasons/currentSeason"];
    },
    weeks() {
      var weeks = [];
      var game;

      for (game of this.currentSchedule) {
        if (!weeks.includes(game.weekNumber)) {
          weeks.push(game.weekNumber);
        }
      }

      return weeks;
    },
    nextWeek() {
      console.group("nextWeek");
      // determine next week based on first missing winner in the current schedule
      // console.info("currentSchedule");
      // console.table(this.currentSchedule);

      for (var i = 0; i < this.currentSchedule.length; i++) {
        if (
          this.currentSchedule[i].winner === null ||
          this.currentSchedule[i].winner === ""
        ) {
          console.groupEnd();
          return this.currentSchedule[i].weekNumber;
        }
      }

      // we got here if all weeks have a winner, so just switch to the last week
      console.groupEnd();
      return this.currentSchedule[this.currentSchedule.length - 1].weekNumber;
    },
    preTournament() {
      console.group("preTournament");
      console.info(
        "preTournament = ",
        this.currentSeason.tournamentPickingOpen
      );
      console.groupEnd();
      return this.currentSeason.tournamentPickingOpen === true;
    },
    dataChanged() {
      console.group("dataChanged");
      const games = this.weekGames(this.showWeek);

      for (var i = 0; i < games.length; i++) {
        if (
          games[i].winner !== this.currentSchedule[games[i].gameId - 1].winner
        ) {
          // changed winner
          console.info("data was changed");
          console.groupEnd();
          return true;
        }
      }

      // no changes made
      console.info("data was not changed");
      console.groupEnd();
      return false;
    },
  },
  data() {
    return {
      showWeek: 1,
      seasonGames: [],
      error: {
        description: null,
        focusField: null,
        nextURL: null,
      },
    };
  },
  beforeMount() {
    console.group("beforeMount");
    this.showWeek = this.nextWeek;
    console.info("showWeek = ", this.showWeek);

    this.loadSchedule();

    console.info("seasonGames");
    console.table(this.seasonGames);
    console.groupEnd();
  },
  methods: {
    switchWeek(week) {
      if (this.preTournament && week > 1) {
        this.error.description =
          "Cannot update results beyond week 1 until tournament picking is closed.";
        this.error.focusField = "week_1";
        return;
      }

      // check if any changes were made in this week and prompt to save if there were
      // don't need to do this if I use the reset button as described below

      if (this.dataChanged) {
        // changes were made, confirm changes
      }
      // ===>code for checking for changes goes here<===

      // reset the list so we are clean again (or I could add a "reset" button next to
      // the "save" button that is normally disabled and enable it if changes are made

      // ===>code for resetting the list goes here<===

      this.showWeek = week;
    },
    weekGames(week) {
      return this.seasonGames.filter((game) => {
        return game.weekNumber === week;
      });
    },
    handleError() {
      this.error.description = null;
      if (this.error.focusField !== null) {
        this.focusOnField(this.error.focusField);
        this.error.focusField = null;
      }

      if (this.error.nextURL) {
        const nextURL = this.error.nextURL;
        this.error.nextURL = null;
        this.$router.push(nextURL);
      }
    },
    focusOnField(ref) {
      this.$refs[ref].focus();
    },
    loadSchedule() {
      console.group("loadSchedule");
      this.seasonGames = [];

      console.info("assigning currentSchedule to seasonGames");
      console.table(this.currentSchedule);

      for (var i = 0; i < this.currentSchedule.length; i++) {
        var game = new Object();
        Object.assign(game, this.currentSchedule[i]);
        this.seasonGames.push(game);
      }

      console.groupEnd();
    },
    async saveChanges() {
      console.group("saveChanges");
      // save changes for 'showWeek';

      // don't allow saving changes if showWeek is > 1 and we're in pre-tournament
      if (this.showWeek > 1 && this.preTournament) {
        this.error.description =
          "Unable to save changes for " +
          this.showWeek +
          " while tournament picks are still open";
        this.error.focusField = "week_1";
      } else {
        console.info("this.weekGames");
        console.table(this.weekGames(this.showWeek));

        try {
          await this.$store.dispatch("schedules/saveSchedule", this.seasonGames);
        } catch (err) {
          this.error.description = err;
        }

        // re-write schedule from currentSchedule
        this.loadSchedule();
        if ( this.error.description === null ) {
          this.openSnackbar("Saved Successfully", "success");
        }

        console.info("this.currentSchedule for week ", this.showWeek);
        console.table(
          this.currentSchedule.filter((game) => {
            return game.weekNumber === this.showWeek;
          })
        );
      }

      console.groupEnd();
    },
    resetChanges() {
      console.group("resetChanges");
      // put the current week's changes (winners) back to the original values
      const games = this.weekGames(this.showWeek);

      for (var i = 0; i < games.length; i++) {
        games[i].winner = this.currentSchedule[games[i].gameId - 1].winner;
      }

      console.groupEnd();
    },
    weeksListStyle(week) {
      var styles = "";

      if ( week === this.showWeek ) {
        styles = styles + " weeks--list--active"
      }

      if ( week < this.nextWeek ) {
        styles = styles + " weeks--list--complete"
      } else {
        styles = styles + " weeks--list--incomplete"
      }
      
      if ( this.preTournament && week > 1 ) {
        styles = styles + " weeks--list--closed"
      }

      return styles;
    },
    weekPoints(week) {
      const schedule = this.$store.getters["schedules/currentSchedule"];
      const weekGames = schedule.filter((game) => {
        return game.weekNumber === week;
      });

      if (weekGames.length > 0) {
        return weekGames[0].points;
      } else {
        // error
        return 0;
      }
    },
  },
};
</script>

<style scoped>
.picks--complete {
  font-size: small;
  padding-top: 0;
}

.nickname {
  width: 60%;
}

.list--weeks {
  list-style-type: none;
  padding: 0;
  max-width: 95%;
}

.list--weeks li {
  margin: 0.5rem 0;
}

.filter--team {
  float: right;
  margin-right: 2rem;
  min-width: 10ch;
}

.div--visitor {
  display: inline-block;
  color: orange;
  justify-content: left;
  width: 40%;
}

.div--home {
  display: inline-block;
  color: green;
  justify-content: right;
  width: 40%;
}

.div--tie,
.div--none {
  display: inline-block;
  color: #033111;
  justify-content: center;
  width: 10%;
}

.buttons--list {
  float: right;
}

.button--save {
  /* position: relative;
  right: 0;
  bottom: 0; */
  /* margin-left: 0; */
  min-width: 10ch;
}

.team-seed {
  column-count: 3;
  box-sizing: border-box;
  border: solid #033111 2px;
  /* border-bottom: none; */
}

.seed {
  width: 30%;
  text-align: center;
}

.team {
  width: auto;
}

.wl {
  width: 40%;
  text-align: center;
}

.header {
  text-align: center;
}

.div--winner {
  display: inline-block;
  color: green;
  vertical-align: middle;
  width: 50%;
}

.div--loser {
  display: inline-block;
  color: red;
  text-decoration: line-through;
  vertical-align: middle;
  width: 50%;
}

.div--weeks ul {
  margin-left: auto;
  margin-right: auto;
}

.div--weeks div {
  margin-left: auto;
  margin-right: auto;
}

.weeks--list {
  display: inline-block;
  background: blue;
  margin: 8px 4px;
  padding: 4px 8px;
  border: 2px solid blue;
  border-radius: 12px;
  cursor: pointer;
}

.weeks--list--complete {
  color: green;
}

.weeks--list--incomplete {
  color: red;
}

.weeks--list--closed {
  color: grey;
}

.weeks--list--active,
.weeks--list:hover {
  color: white;
  border: 2px solid #FB4F14;
}
</style>